<template>
  <div class="tooltip">
    <div class="tw-flex">
      <ui-icon v-if="icon" size="24" data-test="button-icon" class="tw-mt-3">
        {{ icon }}
      </ui-icon>
      <div class="tooltip__information-wrapper">
        <slot></slot>
      </div>
      <ui-icon
        v-if="isDismissible"
        class="tw-cursor-pointer"
        type="outlined"
        size="24"
        data-test="button-icon"
        @click="emit('onClose')"
        data-test-id="tooltip-close-button"
      >
        close
      </ui-icon>
    </div>
    <div class="tooltip__button-wrapper" data-test-id="tooltip-button">
      <ui-button @click="emit('onClose')"> Got It </ui-button>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  icon: {
    type: String,
  },
  isDismissible: {
    type: Boolean,
    default: true,
  },
});
const emit = defineEmits(['onClose']);
</script>

<style lang="scss" scoped>
.tooltip {
  @apply tw-text-white
  tw-text-sm
  tw-relative
  tw-bg-informational-dark
  tw-pr-2
  tw-pl-6
  tw-py-4
  tw-z-30
  tw-rounded;

  left: -52px;
  top: 8px;

  .tooltip__information-wrapper {
    @apply tw-flex
    tw-flex-col
    tw-mx-3
    tw-mt-3;
  }
}

.tooltip::after {
  @apply tw-absolute
  tw-border-solid;
  content: ' ';
  margin-left: -5px;
  border-width: 5px;
  border-color: transparent transparent theme('colors.informational.dark')
    transparent;
  bottom: 100%;
  left: 50%;
}

.tooltip__button-wrapper {
  @apply tw-flex
  tw-justify-end
  tw-mt-3
  tw-mr-3;
}

:deep() {
  .mdc-button__ripple {
    @apply tw-bg-transparent;
  }

  .mdc-button__label {
    @apply tw-normal-case
      tw-font-medium
      tw-tracking-normal
      tw-text-white;
  }

  .mdc-button__ripple:before {
    @apply tw-bg-transparent;
  }

  .mdc-button__ripple:focus {
    @apply tw-bg-transparent;
  }
}
</style>
